import {
  axiosInstance
} from './axiosInstance';
import { handleErrorResponse } from '../../helpers/handleErrorResponse';

export const businessVerification = async (data) => {
  let response;
  try {
    response = await axiosInstance.post('/business-verification', data);
  } catch (err) {
    response = handleErrorResponse(err, data);
  }

  return response;
};